import React from 'react'
import Tooltip from '@mui/material/Tooltip'
import IconButton from '@mui/material/IconButton'
import { styledButtonWithIcon } from './styles'
import { IButtonWithIconProps } from './types'

export const ButtonWithIcon: React.FC<IButtonWithIconProps> = ({
  onClick,
  tooltipText,
  children,
  color = 'primary',
  type = 'button',
  ...rest
}) => {
  return (
    <Tooltip title={tooltipText || ''} placement="top" arrow>
      <IconButton
        color={color}
        aria-label={tooltipText}
        onClick={onClick}
        type={type}
        sx={(theme) => styledButtonWithIcon(theme, color)}
        {...rest}
      >
        {children}
      </IconButton>
    </Tooltip>
  )
}
